<template>
    <NuxtLayout name="main-small" dark>
        <div class="container pt-[80px]" v-if="data">
            <h1 class="text-[36px] text-emphas leading-[52px] font-bold text-center">{{ data.title }}</h1>
            <p class="mt-[32px] text-center">{{ data.date }}</p>

            <section class="mt-[64px]" v-html="data.content"></section>

            <section class="mt-[72px]" v-if="data.url">
                <span class="pr-[4px] text-emphas font-bold">{{ $t("Reference", 2) }}:</span
                ><project-route :to="data.url" target="_blank" :class="css_normalize.assets">{{ data.url }}</project-route>
            </section>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* route
const route = useRoute();
//* 样式
import css_normalize from "@/assets/style/src/index.module.less";
//* 获取初始数据
const options = await api.server("CitationsDetails", "/api/citations/details", { method: "POST", data: { id: route.params.id || "" } });
const { data } = options.value || {};
</script>
